import React from "react";
import "./Footer.css";
import logoImage from "../assets/logo.png";

const Footer = () => {
  return (
    <footer className="main-footer">
      <div className="footer-inner">
        <div className="footer-logo">
          <img src={logoImage} alt="logo" />
        </div>
        <div className="footer-links">
          {/* 링크들 */}
        </div>
      </div>
    </footer>
  );
};

export default Footer;
